<div class="contacts">
  <div class="contacts__inner">
    <a class="contacts__logo" routerLink="/">
      <span class="contacts__logo-icon">🚚</span>
      <span class="contacts__logo-text">Bilload</span>
    </a>

    <h1>{{ titleText }}</h1>
    <p class="contacts__subtitle">{{ subtitleText }}</p>

    <div class="contacts__card">
      <div class="contacts__company">{{ companyName }}</div>

      <div class="contacts__row">
        <span class="contacts__row-label">{{ phoneLabel }}</span>
        <a [href]="contactPhoneHref" class="contacts__row-value">{{ contactPhone }}</a>
      </div>

      <div class="contacts__row">
        <span class="contacts__row-label">{{ whatsappLabel }}</span>
        <a [href]="contactWhatsappHref" target="_blank" rel="noopener" class="contacts__row-value contacts__whatsapp">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
            <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.39 1.26 4.82L2 22l5.4-1.42a9.9 9.9 0 0 0 4.64 1.18h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2zm5.8 14.1c-.24.68-1.4 1.3-1.93 1.38-.49.08-1.11.11-1.79-.11-.41-.13-.94-.3-1.62-.6-2.86-1.24-4.72-4.12-4.86-4.31-.14-.19-1.16-1.54-1.16-2.94 0-1.4.73-2.08.99-2.37.26-.28.57-.35.76-.35.19 0 .38 0 .55.01.17.01.41-.07.64.49.24.58.81 2 .88 2.14.07.14.12.31.02.5-.1.19-.15.31-.29.48-.14.17-.3.37-.43.5-.14.14-.29.29-.13.57.17.28.74 1.22 1.58 1.98 1.09.97 2 1.27 2.29 1.41.29.14.46.12.63-.07.17-.19.72-.84.92-1.13.19-.28.38-.24.64-.14.26.1 1.67.79 1.95.93.29.14.48.21.55.33.07.12.07.68-.17 1.36z"/>
          </svg>
          {{ contactPhone }}
        </a>
      </div>

      <div class="contacts__row">
        <span class="contacts__row-label">{{ emailLabel }}</span>
        <a [href]="'mailto:' + contactEmail" class="contacts__row-value">{{ contactEmail }}</a>
      </div>
    </div>
  </div>
</div>
